(function () {
  function loadKlaviyoScript() {
    if (document.querySelector('script[src*="klaviyo.js"]')) return;
    var script = document.createElement('script');
    script.async = true;
    script.src = 'https://static.klaviyo.com/onsite/js/klaviyo.js?company_id=LWTdWS';
    document.head.appendChild(script);
  }

  function getKlaviyoForm(root) {
    var formBox = root.querySelector('.sign-up-banner__form-box');
    if (!formBox) return null;
    return formBox.querySelector('form[data-testid^="klaviyo-form-"]');
  }

  function getKlaviyoSubmitButton(root) {
    var form = getKlaviyoForm(root);
    if (!form) return null;
    return (
      form.querySelector('button[type="submit"]') ||
      form.querySelector('[data-testid="form-row"] button') ||
      form.querySelector('button')
    );
  }

  function syncHiddenKlaviyoConsent(root) {
    var formBox = root.querySelector('.sign-up-banner__form-box');
    if (!formBox) return;

    formBox.querySelectorAll('input[type="checkbox"]').forEach(function (input) {
      if (input.checked) return;
      input.checked = true;
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  function initBanner(root) {
    if (!root || root.dataset.signUpReady === 'true') return;
    root.dataset.signUpReady = 'true';

    loadKlaviyoScript();

    var formId = root.getAttribute('data-form-id') || 'U5f95f';
    var checkbox = root.querySelector('[data-sign-up-checkbox]');
    var gate = root.querySelector('[data-sign-up-gate]');
    var tip = root.querySelector('[data-sign-up-tip]');
    var successTitle = root.querySelector('.sign-up-banner__success-title');
    var klaviyoContainer = root.querySelector('[class*="klaviyo-form-"]');

    function setGateVisible(visible) {
      if (!gate) return;
      gate.classList.toggle('is-hidden', !visible);
      gate.setAttribute('aria-hidden', visible ? 'false' : 'true');
    }

    function hideTip() {
      if (tip) tip.hidden = true;
    }

    function showTip() {
      if (tip) tip.hidden = false;
    }

    function termsAccepted() {
      return !checkbox || checkbox.checked;
    }

    function updateGate() {
      if (!gate) return;
      setGateVisible(!termsAccepted());
    }

    function bindKlaviyoSubmit() {
      var submitButton = getKlaviyoSubmitButton(root);
      if (!submitButton || submitButton.dataset.signUpBound === 'true') {
        return !!submitButton;
      }

      submitButton.dataset.signUpBound = 'true';

      submitButton.addEventListener(
        'click',
        function (event) {
          if (!termsAccepted()) {
            event.preventDefault();
            event.stopImmediatePropagation();
            showTip();
            return;
          }

          hideTip();
          syncHiddenKlaviyoConsent(root);
        },
        true
      );

      updateGate();
      return true;
    }

    updateGate();

    if (checkbox) {
      checkbox.addEventListener('change', function () {
        if (checkbox.checked) {
          hideTip();
        }
        updateGate();
      });
    }

    if (gate) {
      gate.addEventListener('click', function (event) {
        event.preventDefault();

        if (!termsAccepted()) {
          showTip();
          return;
        }

        hideTip();
        syncHiddenKlaviyoConsent(root);

        var submitButton = getKlaviyoSubmitButton(root);
        if (submitButton) {
          submitButton.click();
        }
      });
    }

    if (!bindKlaviyoSubmit() && klaviyoContainer) {
      var observer = new MutationObserver(function () {
        if (bindKlaviyoSubmit()) {
          observer.disconnect();
        }
      });

      observer.observe(klaviyoContainer, {
        childList: true,
        subtree: true
      });
    }

    window.addEventListener('klaviyoForms', function (event) {
      if (!event.detail) return;
      if (String(event.detail.formId) !== String(formId)) return;
      if (event.detail.type !== 'submit') return;

      root.classList.add('is-success');
      if (successTitle) successTitle.hidden = false;
    });
  }

  function initAll() {
    document.querySelectorAll('[data-sign-up-banner]').forEach(initBanner);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section =
      event.target && event.target.querySelector
        ? event.target.querySelector('[data-sign-up-banner]')
        : null;
    if (section) {
      section.dataset.signUpReady = '';
      initBanner(section);
    }
  });
})();
